import { capitalize } from "@msuite/utils/strings";

/** Props Interface */
interface RoleDisplayNameCandidate {
	name: string;
	isSystem: boolean;
}

/**
 * The name a role is rendered under. The system roles are stored lowercase (`admin`, `member`)
 * and shown capitalised; a display transform is safe because their names are immutable. A
 * customer-defined role renders exactly as it was typed — its casing is the organisation's own.
 *
 * @param role - The role's name and system flag, as the list and detail endpoints return them.
 * @returns The name to render.
 */
export function roleDisplayName({ name, isSystem }: RoleDisplayNameCandidate): string {
	return isSystem ? capitalize(name) : name;
}
